<script setup lang="ts">
  /** Visual hint for fields accepting multiple values. */
</script>

<template>
  <span class="shrink-0 select-none px-px text-[13px] leading-none text-viking-400 duration-300 group-hover:text-viking-500" aria-hidden="true">
    <Icon name="plus" />
  </span>
</template>
